





















































































import PanelGroup from "./components/PanelGroup.vue";
import LineChart from "./components/LineChart.vue";
import BoxCard from "./components/BoxCard.vue";
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { overviewRequest, OverviewReq, History } from "@/api/admin";
import {
  ResCode,
  Meter,
  MeterType,
  MeterFault,
  MeterAlarm,
} from "@/api/baseDefine";
import {
  formatDate,
  formatDateTime,
  formatHour,
  formatMonth,
  formatYear,
} from "@/utils/dateUtil";
import { MeterUtil } from "@/utils/meterUtil";
import { format } from "path";
const lineChartData = {
  xDatas: ["0"],
  usages: [0],
  readings: [0],
};

@Component({
  components: {
    PanelGroup,
    LineChart,
  },
})
export default class DashboardAdmin extends Vue {
  private meterTypeUnits: string[] = ["m³", "kWh", "m³", "MWh", "kWh"];
  private unit: string = "";
  public lineChartData = lineChartData;
  private meterTypes: string[] = [];
  private timeArray: string[] = [];
  private list: MeterAlarm[] = [];
  private listLoading = false;
  public stateInfos: string[] = [];
  public stateCounts = [0, 0];
  private selectMeterTypeID = 0;
  public countData = [0, 0, 0, 0, 0];
  private time = "";
  private meterType = this.meterTypes[0];
  private overviewReq: OverviewReq = <OverviewReq>{ historyMeterTypeID: 1 };
  private curMeterTypes: MeterType[] = [];
  private selectIndex: number = 0;

  public handleClickPanelGroup(index) {
    this.selectIndex = index;
    this.selectMeterTypeID = this.curMeterTypes[index].id;
    this.overview();
  }

  private change(f) {
    console.log(f);
    this.overview();
  }

  private first: boolean = false;
  private firstMeterTypes: MeterType[] = [];
  private async overview() {
    let timeID = this.timeArray.indexOf(this.time);
    timeID++;
    this.overviewReq.timeID = timeID;
    this.overviewReq.historyMeterTypeID = this.selectMeterTypeID;
    this.overviewReq.yesterday = formatDateTime(
      new Date(Date.now() - 24 * 60 * 60 * 1000)
    );
    this.overviewReq.date = formatDateTime(new Date());
    this.overviewReq.nowDate = formatDate(new Date());
    const res = await overviewRequest(this.overviewReq);
    if (res.code === ResCode.SUCCESS) {
      this.showLine(res.data.historys, timeID);
      this.unit = this.meterTypeUnits[this.selectMeterTypeID - 1];
      this.countData = res.data.meterCount;
      this.stateCounts = [0, 0];
      if (!!this.countData) {
        this.stateCounts[0] = this.countData[this.selectIndex];
      }
      this.list = res.data.meterAlarms;
      if (!!this.list) {
        this.stateCounts[1] = res.data.alarmCount;
        for (let alarm of this.list) {
          let fault = alarm.fault;
          let res = "";
          if (alarm.type == 1) {
            for (let i = 0; i < fault.length; i++) {
              if (fault[i] === "1") {
                if (!res) {
                  res = this.meterFaults[alarm.meterTypeID - 1][8 - i];
                } else {
                  res =
                    res + "," + this.meterFaults[alarm.meterTypeID - 1][8 - i];
                }
              }
            }
            alarm.fault = res;
          } else if (alarm.type == 0) {
            alarm.fault = this.$t("meterState.leakage").toString();
          }
        }
      }
      this.list.sort(function (a: MeterAlarm, b: MeterAlarm) {
        if (a.reportTime > b.reportTime) {
          return -1;
        } else {
          return 1;
        }
      });
    }
    this.curMeterTypes = MeterUtil.getMeterTypeByMeterCounts(
      this.countData,
      this.meterTypes
    );
    if (!this.first) {
      this.first = true;
      this.firstMeterTypes = this.curMeterTypes;
      if (this.curMeterTypes.length >= 1) {
        this.selectMeterTypeID = this.curMeterTypes[0].id;
      }
      this.overview();
    }
  }

  private showLine(lists: History[], timeID: number) {
    this.lineChartData.xDatas = [];
    this.lineChartData.usages = [];
    this.lineChartData.readings = [];
    for (let history of lists) {
      this.lineChartData.usages.push(history.usage);
      this.lineChartData.readings.push(history.reading);
      let time = history.time;
      let times = time.split(" ");
      if (timeID == 1) {
        time = formatHour(new Date(time));
      } else if (timeID == 2) {
        time = times[0];
      } else if (timeID == 3) {
        time = times[0];
      } else if (timeID == 4) {
        time = formatMonth(new Date(time));
      } else {
        time = formatYear(new Date(time));
      }
      this.lineChartData.xDatas.push(time);
    }
  }
  private meterFaults;
  private created() {
    this.meterFaults = [
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s15").toString(),
        this.$t("meterState.s16").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s18").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s21").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s24").toString(),
        this.$t("meterState.s25").toString(),
        this.$t("meterState.s26").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s28").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s32").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s35").toString(),
        this.$t("meterState.s36").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s18").toString(),
      ],
      [
        this.$t("meterState.s10").toString(),
        this.$t("meterState.s11").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s14").toString(),
        this.$t("meterState.s15").toString(),
        this.$t("meterState.s16").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s48").toString(),
      ],
      [
        this.$t("meterState.s50").toString(),
        this.$t("meterState.s51").toString(),
        this.$t("meterState.s12").toString(),
        this.$t("meterState.s13").toString(),
        this.$t("meterState.s54").toString(),
        this.$t("meterState.s25").toString(),
        this.$t("meterState.s26").toString(),
        this.$t("meterState.s17").toString(),
        this.$t("meterState.s58").toString(),
      ],
    ];

    this.meterTypes = [
      this.$t("meterTypes.water").toString(),
      this.$t("meterTypes.power").toString(),
      this.$t("meterTypes.gas").toString(),
      this.$t("meterTypes.hot").toString(),
      this.$t("meterTypes.pv").toString(),
    ];

    this.timeArray = [
      this.$t("timeArray.hours").toString(),
      this.$t("timeArray.days").toString(),
      this.$t("timeArray.weeks").toString(),
      this.$t("timeArray.months").toString(),
      this.$t("timeArray.years").toString(),
    ];
    this.time = this.timeArray[0];

    this.stateInfos = [
      this.$t("stateInfos.totalCount").toString(),
      this.$t("stateInfos.malfunctionCount").toString(),
    ];
    this.overview();
  }
}
